import { icon } from "leaflet";

export const icons = {
  iconStable: icon({
    iconSize: [20, 20],
    iconAnchor: [13, 27],
    popupAnchor:  [1, -24],
    iconUrl: 'marker-icon.png',
  }),
  iconSelected: icon({
    iconSize: [20, 20],
    iconAnchor: [13, 27],
    popupAnchor:  [1, -24],
    iconUrl: 'icon-selected.png',
  })
};
